import MobileAppsHeader from '@propertypal/web-ui/src/headers/mobile-apps/MobileAppsHeader';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import React from 'react';
import { Container, AppStore, PlayStore, Buttons } from './MobileAppsHeaderSection.style';

const MobileAppsHeaderSection = () => {
  return (
    <Container>
      <PageWrapper>
        <MobileAppsHeader />
        <Buttons>
          <a href="https://itunes.apple.com/gb/app/propertypal/id583325320?mt=8">
            <AppStore />
          </a>

          <a href="https://play.google.com/store/apps/details?id=com.propertypal.propertysearch">
            <PlayStore />
          </a>
        </Buttons>
      </PageWrapper>
    </Container>
  );
};

export default MobileAppsHeaderSection;
